import axios from "axios";

import { Errors } from "./Errors";

import store from "../../store";

export class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   * @param {object} vuex
   */
  constructor(data, vuex) {
    this.originalData = data;
    if (vuex) {
      this.vuexEnabled = vuex.enabled;
      this.vuex = vuex;
    } else {
      this.vuexEnabled = false;
      this.vuex = null;
    }

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }

  /**
   * Reset the form fields.
   */
  reset(force) {
    if (force) {
      for (let field in this.originalData) {
        this[field] = "";
      }
    }

    this.errors.clear();
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post(url, options) {
    return this.submit("post", url, options);
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put(url) {
    return this.submit("put", url);
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch(url) {
    return this.submit("patch", url);
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete(url) {
    return this.submit("delete", url);
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   */
  submit(requestType, url, options) {
    //console.log(requestType, url);
    return axios[requestType](url, this.data(), options)
      .then((response) => {
        this.onSuccess(response.data);
        return response.data;
      })
      .catch((error) => {
        this.onFail(error.response.data.errors);
        throw error;
      });
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess() {
    if (!this.vuexEnabled) {
      this.reset();
    }
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    if (this.vuexEnabled) {
      store.commit(this.vuex.actions.onFail, errors);
    } else {
      this.errors.record(errors);
    }
  }
}
